//https://www.npmjs.com/package/container-query-polyfill
import "container-query-polyfill";

export default () => {
    // console.log('container-query-polyfill loaded!')
};
